import { RootState } from 'editor/src/store/index';

const getCategoryId = (state: RootState) => state.editorModules.addons.data?.categoryId;

export default getCategoryId;
